import mapboxgl from 'mapbox-gl';
import '../../../../node_modules/mapbox-gl/dist/mapbox-gl.css';

export default class Map {
  constructor(
    props = {
      mapId: '',
      style: '',
      center: [0, 0],
      zoom: 9,
      iconSize: 50,
      locations: [],
    }
  ) {
    this.map = null;

    this.mapId = props.mapId;
    this.style = props.style;
    this.center = props.center;
    this.zoom = props.zoom;
    this.iconSize = props.iconSize;
    this.locations = props.locations;
  }

  init() {
    mapboxgl.accessToken =
      'pk.eyJ1Ijoicm9iaW52ZXJoZXlkZW4iLCJhIjoiLVNTNFEwZyJ9.aC0iuMgDGqdUDqTmn8oMcg';

    this.map = new mapboxgl.Map({
      container: this.mapId,
      style: this.style,
      center: this.center,
      zoom: this.zoom,
    });

    //disable zooms
    this.map.scrollZoom.disable();
    this.map.keyboard.disable();

    this.onLoad();
  }

  onLoad() {
    this.map.on('load', () => {
      this.createMarkers();
    });
  }

  createMarkers() {
    this.locations.forEach((loc) => {
      const elem = document.createElement('div');

      elem.classList.add('schools__map-marker');

      elem.style.width = `28px`;
      elem.style.height = `35px`;

      // Add markers to the map.
      new mapboxgl.Marker(elem).setLngLat(loc.pos).addTo(this.map);
    });
  }
}
